// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"550px","mainHeading":"main-header_mainHeading__fCZcb","redesign":"main-header_redesign__dlsjX","subHeading":"main-header_subHeading__JpjwM"};